import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllCommissionConfigurations = async () => {
  try {
    const res = await request.get(Constants.get_all_commissions_configurations);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const createCommissionConfig = async (data) => {
  try {
    const res = await request.post(Constants.create_commission_api_url, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const updateCommissionConfig = async (id, data) => {
  try {
    const res = await request.patch(
      `${Constants.update_commission_api_url}/${id}`,
      data
    );
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const deleteCommissionConfig = async (id) => {
  try {
    const res = await request.delete(
      `${Constants.delete_commission_api_url}/${id}`);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
